import {Injectable} from '@angular/core';
import {Meta} from '@angular/platform-browser';
import {SeoSocialShareService} from 'ngx-seo';
import {environment} from '#env';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private readonly seo: SeoSocialShareService,
              private meta: Meta) {
  }

  generateTags(config: any = {}) {
    let image = `${environment.baseUrl}/assets/images/banners/default.jpg`;
    if (config.externalImage) {
      image = config.externalImage;
    } else if (config.image) {
      image = `${environment.baseUrl}/${config.image}`;
    }

    const url = `${environment.baseUrl}/${config.slug || ''}`;
    const title = config.title || 'SmartBite for Vendors | Grow and Expand your Catering Business';
    const description = config.description || 'Increase sales from day one in the smartest way possible! ' +
      'Reach a wider range of customers and get more feedback.';

    // page title and description
    this.seo.setTitle(title);
    this.seo.setDescription(description);
    this.seo.setUrl(url);
    this.seo.setCanonicalUrl(url);
    this.seo.setImage(image);
    this.seo.setType(config.type || 'website');
    this.seo.setAuthor(config.author);
    this.seo.setPublished(config.published);
    this.seo.setModified(config.modified);
    this.meta.updateTag({property: 'og:url', content: url});
    this.meta.updateTag({property: 'og:title', content: title});
    this.meta.updateTag({property: 'og:image', content: image});
    this.meta.updateTag({property: 'og:description', content: description});
  }
}
